App.DishSuggestionComponent = Em.Component.extend
  classNames: [ 'dish-suggestion' ]

  click: (event) ->
    @sendAction('action', @get('dish'))